/**
 * @file Local storage keys.
 */

/**
 * Storage keys.
 */
const StorageKeys = {
  PKCE_CODE_VERIFIER: 'pkce-code-verifier',
};

export default StorageKeys;
